import { useQuery } from '@tanstack/react-query';
import { authenticatedFetch } from '@/utils/apiUtils';
import { getApiUrl } from '@/config/api';
import type { AthleteSummary } from '../types';

export function useCalendarRoster(enabled = true) {
  return useQuery({
    queryKey: ['calendar', 'roster'],
    queryFn: async (): Promise<AthleteSummary[]> => {
      const r = await authenticatedFetch(
        getApiUrl('/api/calendar/athletes/'),
        { method: 'GET' },
        'fetching calendar roster',
      );
      if (!r.success) throw new Error(r.error || 'roster fetch failed');
      return (r.data as { athletes: AthleteSummary[] }).athletes;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
